<script setup lang="ts">
  import InfoIcon from '@/shared/components/icons/InfoIcon.vue'
  import { useMobileDetector } from '@/shared/composables'

  // TODO: refactor isCovid props with slots
  interface Props {
    title: string
    desc?: string
    risk?: string
    isPriceLoading: boolean
    isCovid?: boolean
    showRisk?: boolean
    isMobileLayoutEqualToWeb?: boolean
    coverLimit: string
  }

  withDefaults(defineProps<Props>(), {
    isCovid: true,
    showRisk: false,
    isMobileLayoutEqualToWeb: false,
  })

  const { isMobile } = useMobileDetector()
</script>

<template>
  <div class="cover-block">
    <div class="cover-block__header">
      <slot name="pre"></slot>
      <div
        :class="[
          'cover-block__title',
          { 'cover-block__title--web-equal-layout': isMobileLayoutEqualToWeb },
        ]"
      >
        <div
          :class="[
            'cover-block__title-inner',
            { 'cover-block__title-inner--web-equal-layout': isMobileLayoutEqualToWeb },
          ]"
        >
          <p>{{ title }}</p>
          <template v-if="!isMobile || isMobileLayoutEqualToWeb">
            <div
              v-if="desc"
              :class="[
                'cover-block__desc',
                { 'cover-block__desc--web-equal-layout': isMobileLayoutEqualToWeb },
              ]"
            >
              <span>{{ desc }}</span>
              <div v-if="coverLimit">
                <span class="cover-block__desc-limit">{{ $t('qic.common.insuranceLimit') }}</span>
                <span>&nbsp;{{ coverLimit }}</span>
              </div>
            </div>
          </template>
          <div
            v-else
            class="cover-block__price"
            :class="{ 'cover-block__price--disabled': isPriceLoading && isCovid }"
          >
            <slot name="price" />
          </div>
        </div>
        <template v-if="isMobile && !isMobileLayoutEqualToWeb">
          <div v-if="desc" class="cover-block__desc">
            <span>{{ desc }}</span>
            <div v-if="coverLimit">
              <span class="cover-block__desc-limit">{{ $t('qic.common.insuranceLimit') }}</span>
              <span>&nbsp;{{ coverLimit }}</span>
            </div>
          </div>
        </template>
        <div
          v-else
          class="cover-block__price"
          :class="{ 'cover-block__price--disabled': isPriceLoading && isCovid }"
        >
          <slot name="price" />
        </div>
      </div>
      <Transition name="fade">
        <div v-if="isCovid && showRisk" class="cover-block__risk">
          <InfoIcon />
          {{ risk }}
        </div>
      </Transition>
    </div>

    <div v-if="!isCovid" class="cover-block__list">
      <slot name="travelers" />
      <Transition name="fade">
        <div v-if="showRisk" class="cover-block__risk">
          <InfoIcon />
          {{ risk }}
        </div>
      </Transition>
    </div>

    <div v-if="$slots.body" class="cover-block__list">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import 'CoversBlock';
</style>
